import React from 'react';
import { get } from 'lodash';

import attributeRow from './attribute_row';
import AssignmentPropTypes from '../assignment_prop_types';

export default class AssignmentRequirements extends React.Component {
  static propTypes = {
    ...AssignmentPropTypes
  };

  render() {
    const requirement = this.props.assignment.requirement;
    return (
      <div className="table-container">
        <table className="table">
          <tbody>
            {attributeRow('Assignment Type', requirement.assignmentTypeLabel)}
            {attributeRow('Property Type', requirement.assetTypeLabel)}
            {attributeRow('Client', get(this.props.assignment, 'client.name'))}
            {attributeRow('Company Type', requirement.companyType)}
            {attributeRow('Location', requirement.locationLabel)}
            {attributeRow('Submarket', requirement.submarket)}
            {attributeRow('Size', requirement.sizeRange)}
            {attributeRow('Description', requirement.description)}
            {attributeRow('Rent', requirement.rentRange)}
            {attributeRow('Price', requirement.priceRange)}
            {attributeRow('Cap Rate', requirement.capRate)}
            {attributeRow('Stabilized Cap Rate', requirement.stabilizedCapRate)}
            {attributeRow('5 Year Cash Yield Threshold', requirement.fiveYearCashYieldThreshold)}
            {attributeRow('IRR', requirement.irr)}
          </tbody>
        </table>
      </div>
    );
  }
}
